
import { CheckCircle, CreditCard, RocketIcon, Zap } from "lucide-react";
import { LucideIcon } from "lucide-react";

export const getPlanIcon = (planName?: string): LucideIcon => {
  if (!planName) return CreditCard;
  const name = planName.toLowerCase();
  
  if (name.includes('free')) return CheckCircle;
  if (name.includes('hustle')) return Zap;
  if (name.includes('growth')) return RocketIcon;
  
  return CreditCard;
};

export const getButtonColor = (planName?: string): string => {
  if (!planName) return 'bg-purple-600 hover:bg-purple-700';
  const name = planName.toLowerCase();
  
  if (name.includes('hustle')) return 'bg-gebeya-pink hover:bg-gebeya-pink/90';
  if (name.includes('growth')) return 'bg-blue-600 hover:bg-blue-700';
  if (name.includes('free')) return 'bg-green-600 hover:bg-green-700';
  
  return 'bg-purple-600 hover:bg-purple-700';
};

export const getIconColor = (planName?: string): string => {
  if (!planName) return 'text-purple-600';
  const name = planName.toLowerCase();
  
  if (name.includes('hustle')) return 'text-gebeya-pink';
  if (name.includes('growth')) return 'text-blue-600';
  if (name.includes('free')) return 'text-green-600';
  
  return 'text-purple-600';
};
